import { createSlice } from '@reduxjs/toolkit'
import { register } from '../../../../../helpers/reducerRegistry'
import { postPeerAnalysisSearch } from './thunk'

const slice = createSlice({
  name: 'companyAnalysis/peerAnalysis/search',
  initialState: {
    searchData: [],
    peerOrganizationIds: [],
    isLoading: true,
    isShowPopupCancel: false,
  },
  reducers: {
    changeSearchData: (state, action) => {
      state.searchData = action.payload
    },
    changeIsLoading: (state, action) => {
      state.isLoading = action.payload
    },
    changeIsShowPopupCancel: (state, action) => {
      state.isShowPopupCancel = action.payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(postPeerAnalysisSearch.pending, (state) => {
      state.isLoading = true
      state.searchData = []
    })
    builder.addCase(
      postPeerAnalysisSearch.fulfilled,
      (state, { payload = [] }) => {
        state.isLoading = false
        state.searchData = payload
      },
    )
    builder.addCase(
      postPeerAnalysisSearch.rejected,
      (state, { payload = {} }) => {
        state.isLoading = payload.isLoading
      },
    )
  },
})

export const selectSearchData = (state) => state[slice.name].searchData
export const selectIsShowPopupCancel = (state) =>
  state[slice.name].isShowPopupCancel
export const selectIsLoading = (state) => state[slice.name].isLoading

export const { changeIsLoading, changeSearchData, changeIsShowPopupCancel } =
  slice.actions

register(slice.name, slice.reducer)
